import { Card } from "../../primitives/card";
import type { IssueViewItem } from "@shared-core/data/api-types";
import { issueTypeLabel, formatShortDate } from "@shared-core/domain/issues";
import { ReadField } from "./IssueFields";

/**
 * Read-only report view for a legacy Implog issue. Implog rows are never
 * editable from CIS, so — unlike the platform IssueReportTab — this has no
 * sibling Investigation/Activity tabs: it's the whole detail surface.
 */
export function LegacyIssueReportPanel({ issue }: { issue: IssueViewItem }) {
  return (
    <div className="space-y-5">
      <Card className="p-6 space-y-5">
        <ReadField label="Issue type" value={issueTypeLabel(issue.type_id)} />
        <ReadField
          label="What happened"
          value={issue.legacy_description}
          empty="No description recorded"
        />
        <ReadField
          label="Problem"
          value={issue.legacy_problem}
          empty="No problem recorded"
        />
        <ReadField
          label="Reason"
          value={issue.legacy_reason}
          empty="No reason recorded"
        />
        <ReadField
          label="Initial action taken"
          value={issue.legacy_initial_action}
          empty="No initial action recorded"
        />
        <ReadField
          label="Investigation completed"
          value={
            issue.legacy_date_investigation_complete
              ? formatShortDate(issue.legacy_date_investigation_complete)
              : null
          }
          empty="Not yet completed"
        />
      </Card>
      <p className="text-xs text-muted-foreground">
        This is a legacy CRM record, carried over from before One. It's
        read-only here — investigation and resolution happened in the old
        system.
      </p>
    </div>
  );
}
